/**
 * Billing and credit usage thresholds
 */

/** Percentage threshold at which to show prominent credit usage warnings */
export const CREDIT_WARNING_THRESHOLD = 80;

/** Percentage threshold for "near limit" status */
export const CREDIT_NEAR_LIMIT_THRESHOLD = 90;

/** Percentage threshold for "high usage" status */
export const CREDIT_HIGH_USAGE_THRESHOLD = 80;

/** Sales contact email for custom deals */
export const SALES_EMAIL = "sales@otalytics.com";

/**
 * Master kill-switch for the self-serve pricing page, upgrade modals, and Stripe checkout.
 *
 * Driven by `NEXT_PUBLIC_SELF_SERVE_PRICING_ENABLED`. Next.js inlines `NEXT_PUBLIC_*`
 * at `next build`, so restarting the web container does not flip this. The build arg
 * is already declared in `apps/web/Dockerfile` and passed from
 * `.github/workflows/release.yml`. The kill-switch is the GitHub Actions variable
 * `NEXT_PUBLIC_SELF_SERVE_PRICING_ENABLED` plus a web rebuild.
 *
 * Defaults to disabled: unset, empty, or any value other than the literal string "true"
 * resolves to false.
 *
 * The full `process.env.NEXT_PUBLIC_...` literal is required here — this constant is read
 * from client components, and Next.js only inlines the value for the browser bundle when
 * the key is written out statically (no destructuring, no dynamic lookup).
 */
export const SELF_SERVE_PRICING_ENABLED =
  process.env.NEXT_PUBLIC_SELF_SERVE_PRICING_ENABLED === "true";
